// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShareAltOutlinedSvg from "@ant-design/icons-svg/es/asn/ShareAltOutlined";
import AntdIcon from '../components/AntdIcon';

var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShareAltOutlinedSvg
  }));
};

ShareAltOutlined.displayName = 'ShareAltOutlined';
export default React.forwardRef(ShareAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShareAltOutlined.js
// module id = 1783
// module chunks = 0